import { Component, Input } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-file-download",
  templateUrl: "./file-download.component.html",
  styleUrls: ["./file-download.component.scss"]
})
export class FileDownloadComponent {

  @Input() public title: string;
  @Input() public fileName: string;
  @Input() public getPath: string;
  @Input() public isTrigger?: boolean;

  public constructor(
    private readonly http: HttpClient
  ) {
  }


  public async download(): Promise<void> {
    if (this.isTrigger) {
      try {
        await this.http.post(this.getPath, null).toPromise();
      } catch (error) {
        if (error instanceof HttpErrorResponse) {
          alert(error.error);
        } else if (error instanceof Error) {
          alert(error.message);
        } else {
          alert("Unknown error");
        }
      } finally {
        alert("Der Export wird im Hintergrund erzeugt und steht bald auf der Seite 'Aktivität' zur Verfügung.");
      }
    } else {
      window.open(
        this.getPath,
        "_blank"
      );
    }
  }
}
